/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Charyung Kim (crkim@rsupport.com)
 *
 * @description
 *
 * @created at Fri Nov 29 2024
 **/

import useWhiteboardStore from "../../../stores/useWhiteboardStore";

export function CursorIcon() {
	return (
		<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M6.93863 5.56586C6.78417 5.50474 6.60816 5.54121 6.4907 5.65867C6.37324 5.77613 6.33677 5.95214 6.39789 6.1066L10.4071 16.2395C10.4587 16.37 10.5726 16.4658 10.71 16.4942C10.8474 16.5227 10.9899 16.4801 11.0892 16.3809L13.562 13.908L20.196 20.5419C20.5214 20.8674 21.0491 20.8674 21.3745 20.5419C21.6999 20.2165 21.6999 19.6888 21.3745 19.3634L14.7406 12.7295L17.2129 10.2571C17.3121 10.1579 17.3547 10.0154 17.3263 9.87796C17.2978 9.74055 17.202 9.6267 17.0716 9.57506L6.93863 5.56586Z"
				fill="white"
			/>
		</svg>
	);
}

export function PointerIcon() {
	return (
		<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M14.0002 4.8335C19.0628 4.8335 23.1668 8.93755 23.1668 14.0002C23.1668 19.0628 19.0628 23.1668 14.0002 23.1668C8.93755 23.1668 4.8335 19.0628 4.8335 14.0002C4.8335 8.93755 8.93755 4.8335 14.0002 4.8335ZM14.0002 6.50016C9.85803 6.50016 6.50016 9.85803 6.50016 14.0002C6.50016 18.1423 9.85803 21.5002 14.0002 21.5002C18.1423 21.5002 21.5002 18.1423 21.5002 14.0002C21.5002 9.85803 18.1423 6.50016 14.0002 6.50016Z"
				fill="white"
			/>
			<path
				d="M14 9C16.7614 9 19 11.2386 19 14C19 16.7614 16.7614 19 14 19C11.2386 19 9 16.7614 9 14C9 11.2386 11.2386 9 14 9ZM14 10.6667C12.1591 10.6667 10.6667 12.1591 10.6667 14C10.6667 15.8409 12.1591 17.3333 14 17.3333C15.8409 17.3333 17.3333 15.8409 17.3333 14C17.3333 12.1591 15.8409 10.6667 14 10.6667Z"
				fill="white"
			/>
		</svg>
	);
}

export function FreelineIcon() {
	return (
		<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M16.2411 5.6665C16.659 5.6665 17.0379 5.73396 17.374 5.87527C17.7098 6.01646 17.9982 6.21602 18.2314 6.47226C18.4582 6.72152 18.6281 7.01142 18.7393 7.33596C18.8446 7.64334 18.897 7.96614 18.897 8.30111C18.897 8.46193 18.8869 8.62266 18.8667 8.78312C18.8466 8.9429 18.8166 9.10226 18.7791 9.25109C18.6559 9.77122 18.4767 10.277 18.2418 10.7676C18.0117 11.2483 17.7394 11.7117 17.4252 12.1575C17.1103 12.6043 16.7551 13.0261 16.3599 13.4228C15.9681 13.8161 15.5514 14.1765 15.1118 14.5024C14.3502 15.0704 13.5191 15.5416 12.6198 15.9153C12.2285 16.078 11.7774 15.8974 11.6123 15.5119C11.4472 15.1264 11.6305 14.6821 12.0219 14.5194C12.8041 14.1942 13.5242 13.786 14.1852 13.2931C14.565 13.0115 14.9239 12.7011 15.2621 12.3616C15.5968 12.0255 15.8966 11.6695 16.1618 11.2934C16.4276 10.9162 16.6571 10.5256 16.8507 10.1214C17.0394 9.72699 17.1828 9.32243 17.2837 8.89689C17.3089 8.7964 17.3278 8.69647 17.3403 8.59696C17.3527 8.49814 17.3589 8.39958 17.3589 8.30111C17.3589 8.12878 17.3331 7.96963 17.2819 7.82044C17.2367 7.68841 17.172 7.5781 17.086 7.48351C17.0063 7.39592 16.9037 7.32491 16.7702 7.26881C16.6371 7.21284 16.4619 7.18166 16.2411 7.18166C16.0413 7.18166 15.8551 7.20782 15.6803 7.25955C15.4573 7.3255 15.2407 7.40148 15.0403 7.48322C14.3121 7.79279 13.6232 8.15801 12.9731 8.57902C12.3196 9.0022 11.7118 9.46769 11.1529 9.97231C10.8307 10.267 10.5075 10.5909 10.1833 10.9441C9.86096 11.2953 9.55062 11.6683 9.25228 12.0634C8.95518 12.4569 8.6798 12.8636 8.42608 13.2838C8.17671 13.6967 7.9613 14.1152 7.77961 14.5395C7.59962 14.9598 7.45767 15.3785 7.35343 15.7958C7.25388 16.1943 7.20462 16.5789 7.20462 16.9507C7.20462 17.4914 7.30172 17.9953 7.4956 18.4676C7.68735 18.9348 7.96015 19.3372 8.31723 19.6809C8.67647 20.0266 9.11512 20.3023 9.63908 20.5085C10.1608 20.7138 10.7534 20.818 11.4214 20.818C11.9585 20.818 12.4807 20.762 12.9891 20.6502C13.5239 20.5326 14.0476 20.3856 14.5608 20.2091C15.3151 19.9504 16.0374 19.6447 16.7281 19.2922C17.4208 18.9387 18.0819 18.5436 18.7124 18.1063C18.8403 18.0178 18.9665 17.9294 19.0911 17.841C19.1984 17.7648 19.2981 17.6869 19.39 17.6074C19.7092 17.3313 20.1951 17.3624 20.4754 17.6768C20.7556 17.9912 20.724 18.4699 20.4048 18.7459C20.2752 18.8581 20.1369 18.9662 19.9901 19.0704C19.8605 19.1623 19.7293 19.2543 19.5972 19.3457C18.9104 19.822 18.1899 20.2527 17.4357 20.6376C16.6795 21.0235 15.8897 21.3576 15.0673 21.6398C14.4981 21.8355 13.9171 21.9986 13.3243 22.129C12.7052 22.2651 12.0705 22.3332 11.4214 22.3332C10.5644 22.3332 9.77857 22.195 9.06845 21.9155C8.36061 21.637 7.74995 21.2532 7.24235 20.7647C6.73261 20.2741 6.34063 19.6958 6.06964 19.0356C5.80078 18.3806 5.6665 17.6838 5.6665 16.9507C5.6665 16.4544 5.7313 15.9484 5.85987 15.4337C5.98373 14.9379 6.15136 14.4434 6.36243 13.9506C6.57179 13.4617 6.81911 12.9812 7.10418 12.5091C7.3849 12.0443 7.68957 11.5943 8.01815 11.1591C8.34548 10.7256 8.6869 10.3152 9.0424 9.92791C9.396 9.54271 9.75057 9.18741 10.1099 8.8587C10.7335 8.29569 11.4064 7.7804 12.1281 7.31297C12.8532 6.84338 13.621 6.43637 14.441 6.08783C14.6998 5.98217 14.9654 5.88904 15.2378 5.80844C15.5583 5.71361 15.8935 5.6665 16.2411 5.6665Z"
				fill="white"
			/>
		</svg>
	);
}

export function LineIcon() {
	return (
		<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M7.57754 20.4228C7.2521 20.0973 7.2521 19.5697 7.57754 19.2442L19.3626 7.45913C19.6881 7.13369 20.2157 7.13369 20.5412 7.45913C20.8666 7.78456 20.8666 8.3122 20.5412 8.63764L8.75605 20.4228C8.43061 20.7482 7.90297 20.7482 7.57754 20.4228Z"
				fill="white"
			/>
		</svg>
	);
}

export function ArrowIcon() {
	return (
		<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M14.0002 8.04766C14.0002 7.58742 14.3733 7.21434 14.8335 7.21436L19.1567 7.81981C19.1572 7.81804 19.1577 7.81627 19.1583 7.8145L14.8335 7.21436L19.952 7.21453C19.9562 7.21453 19.9605 7.21456 19.9648 7.21462C20.4221 7.21801 20.7918 7.58982 20.7918 8.04796L20.7916 13.1664C20.7916 13.6266 20.4185 13.9997 19.9583 13.9997C19.498 13.9997 19.1249 13.6266 19.125 13.1663L19.1251 10.0535L8.75609 20.4224C8.43065 20.7479 7.90301 20.7479 7.57757 20.4224C7.25214 20.097 7.25214 19.5694 7.57757 19.2439L17.9404 8.88113L14.8335 8.88102C14.3732 8.88101 14.0001 8.5079 14.0002 8.04766Z"
				fill="white"
			/>
		</svg>
	);
}

export function MarkerIcon() {
	return (
		<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M4 20.4964L7.58705 17.5655L6.79965 16.7781L9.2056 14.4159L11.3491 9.56026L15.3736 5.66699L16.4672 6.71686L13.1426 9.69149L18.7419 15.2033L22.1102 12.1849L23.2476 13.2785L19.1356 17.1718L14.1487 19.2715L11.7428 21.59L10.8679 20.7589L8.85564 22.3337L4 20.4964ZM17.2547 16.2979L12.2678 11.3985L10.5618 15.3355L8.98698 16.7791L11.7429 19.4038L13.2739 17.9165L17.2547 16.2979ZM8.72423 18.6593L9.81785 19.7092L8.54925 20.5841L6.88696 20.0592L8.72423 18.6593Z"
				fill="white"
			/>
		</svg>
	);
}

export function CircleIcon() {
	return (
		<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M13.9998 5.6665C18.6022 5.6665 22.3332 9.39746 22.3332 13.9998C22.3332 18.6022 18.6022 22.3332 13.9998 22.3332C9.39746 22.3332 5.6665 18.6022 5.6665 13.9998C5.6665 9.39746 9.39746 5.6665 13.9998 5.6665ZM13.9998 7.18166C10.2343 7.18166 7.18166 10.2343 7.18166 13.9998C7.18166 17.7654 10.2343 20.818 13.9998 20.818C17.7654 20.818 20.818 17.7654 20.818 13.9998C20.818 10.2343 17.7654 7.18166 13.9998 7.18166Z"
				fill="white"
			/>
		</svg>
	);
}

export function RectIcon() {
	return (
		<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M5.6665 8.1665C5.6665 6.78579 6.78579 5.6665 8.1665 5.6665H19.8332C21.2139 5.6665 22.3332 6.78579 22.3332 8.1665V19.8332C22.3332 21.2139 21.2139 22.3332 19.8332 22.3332H8.1665C6.78579 22.3332 5.6665 21.2139 5.6665 19.8332V8.1665ZM8.1665 7.33317C7.70627 7.33317 7.33317 7.70627 7.33317 8.1665V19.8332C7.33317 20.2934 7.70627 20.6665 8.1665 20.6665H19.8332C20.2934 20.6665 20.6665 20.2934 20.6665 19.8332V8.1665C20.6665 7.70627 20.2934 7.33317 19.8332 7.33317H8.1665Z"
				fill="white"
			/>
		</svg>
	);
}

export function ColorIcon() {
	const penColor = useWhiteboardStore((state) => state.penColor);
	return (
		<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
			<circle cx="14" cy="14" r="10" fill="white" />
			<circle cx="14" cy="14" r="5.5" fill={penColor} />
		</svg>
	);
}

export function ExpandArrowIcon() {
	return (
		<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M12.5304 6.53033L11.4697 5.46967L8.00006 8.939L4.53039 5.46967L3.46973 6.53033L8.00006 11.0607L12.5304 6.53033Z"
				fill="white"
			/>
		</svg>
	);
}

export function EraserIcon() {
	return (
		<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g clipPath="url(#clip0_3312_13)">
				<rect width="19.5935" height="18" transform="translate(6 7)" fill="none" />
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M8.79076 20.2302C8.40198 19.8403 8.40198 19.2079 8.79076 18.8179L14.4299 13.1799L19.4145 18.1645L14.8385 22.7405H11.3022L8.79076 20.2302ZM24.9024 15.6969C25.8239 14.7753 25.8239 13.2802 24.9024 12.3586L20.2358 7.69207C19.3142 6.76931 17.8191 6.76931 16.8976 7.69207L6.69207 17.8964C5.76931 18.8179 5.76931 20.313 6.69207 21.2346L10.4563 25H10.5679H15.6004H25.5935V22.7405H17.8599L24.9024 15.6969Z"
					fill="#fff"
				/>
			</g>
			<defs>
				<clipPath id="clip0_3312_13">
					<rect width="19.5935" height="18" fill="white" transform="translate(6 7)" />
				</clipPath>
			</defs>
		</svg>
	);
}
export function ThicknessIcon() {
	return (
		<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect width="18" height="1" x="5" y="7" fill="white" rx=".75"></rect>
			<rect width="18" height="2" x="5" y="12.5" fill="white" rx="1"></rect>
			<rect width="18" height="3" x="5" y="19" fill="white" rx="1"></rect>
		</svg>
	);
}

export function EmojiIcon() {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.99 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 11.99 22C6.47 22 2 17.52 2 12C2 6.48 6.47 2 11.99 2ZM11.99 3.5C7.3008 3.5 3.5 7.30605 3.5 12C3.5 16.6939 7.3008 20.5 11.99 20.5C16.6903 20.5 20.5 16.6929 20.5 12C20.5 7.30711 16.6903 3.5 11.99 3.5ZM7 9.5C7 8.67157 7.67157 8 8.5 8C9.32843 8 10 8.67157 10 9.5C10 10.3284 9.32843 11 8.5 11C7.67157 11 7 10.3284 7 9.5ZM14 9.5C14 8.67157 14.6716 8 15.5 8C16.3284 8 17 8.67157 17 9.5C17 10.3284 16.3284 11 15.5 11C14.6716 11 14 10.3284 14 9.5ZM16.41 13.89C16.06 13.67 15.59 13.78 15.38 14.13C14.64 15.3 13.38 16 12 16C10.62 16 9.36 15.3 8.62 14.12C8.4 13.77 7.94 13.66 7.59 13.88C7.24 14.1 7.13 14.56 7.35 14.91C8.37 16.54 10.1 17.5 12 17.5C13.9 17.5 15.63 16.53 16.65 14.92C16.87 14.57 16.76 14.11 16.41 13.89Z"
				fill="white"
			/>
		</svg>
	);
}

export function ImageIcon() {
	return (
		<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.5002 4.83301H16.5002C21.1752 4.83301 23.1668 6.82467 23.1668 11.4997V16.4997C23.1668 21.1747 21.1752 23.1663 16.5002 23.1663H11.5002C6.82516 23.1663 4.8335 21.1747 4.8335 16.4997V11.4997C4.8335 6.82467 6.82516 4.83301 11.5002 4.83301ZM7.32516 20.058C8.05016 21.0497 9.35016 21.4997 11.5002 21.4997H16.5002C20.2418 21.4997 21.5002 20.2413 21.5002 16.4997V15.9663L20.4335 15.0497C20.0918 14.758 19.5002 14.758 19.1668 15.0497L15.7002 18.0247C14.7418 18.8497 13.2335 18.8497 12.2668 18.0247L11.9835 17.7747C11.6835 17.5163 11.1502 17.4913 10.8002 17.7247L7.32516 20.058ZM14.6168 16.758L18.0835 13.783V13.7747C19.0418 12.9497 20.5335 12.9497 21.5002 13.758V11.4913C21.5002 7.74967 20.2418 6.49134 16.5002 6.49134H11.5002C7.7585 6.49134 6.50016 7.74967 6.50016 11.4913V16.4913C6.50016 17.258 6.5585 17.908 6.67516 18.4747L9.86683 16.333C10.8252 15.683 12.2085 15.758 13.0752 16.508L13.3585 16.758C13.6918 17.0497 14.2835 17.0497 14.6168 16.758ZM9.00016 10.6663C9.00016 9.29134 10.1252 8.16634 11.5002 8.16634C12.8752 8.16634 14.0002 9.29134 14.0002 10.6663C14.0002 12.0413 12.8752 13.1663 11.5002 13.1663C10.1252 13.1663 9.00016 12.0413 9.00016 10.6663ZM10.6668 10.6663C10.6668 11.1247 11.0418 11.4997 11.5002 11.4997C11.9585 11.4997 12.3335 11.1247 12.3335 10.6663C12.3335 10.208 11.9585 9.83301 11.5002 9.83301C11.0418 9.83301 10.6668 10.208 10.6668 10.6663Z"
				fill="white"
			/>
		</svg>
	);
}

export function TextIcon() {
	return (
		<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g clipPath="url(#clip0_3780_19923)">
				<path
					d="M21.5667 10.3667C21.2667 8.95 21.0667 7.80833 20.975 6.95833L20.925 6.5L20.475 6.59167C19.6 6.775 17.4917 6.86667 14.2 6.86667C10.9083 6.86667 8.93333 6.775 8.05833 6.59167L7.675 6.51667L7.575 6.9C7.24167 8.15 6.89167 9.29167 6.525 10.275L6.5 10.4167C6.5 10.7083 6.7 11.05 7.25833 11.05C7.55 11.05 7.78333 10.8917 7.875 10.6083C8.08333 9.94167 8.50833 9.40833 9.2 8.98333C9.89167 8.55 10.6833 8.33333 11.5417 8.33333H12.325C12.625 8.33333 12.7167 8.38333 12.725 8.38333C12.725 8.38333 12.7667 8.45833 12.7667 8.675V18.825C12.7667 19.2833 12.675 19.6083 12.5083 19.725C12.375 19.8167 12.0167 19.9917 11.05 20.1C10.8 20.1333 10.525 20.325 10.525 20.7833C10.525 21.3 10.8333 21.4833 11.1 21.4833C11.5583 21.4833 12.1 21.4667 12.725 21.425C13.3083 21.3833 13.8 21.3667 14.2 21.3667C14.6 21.3667 15.0667 21.3833 15.65 21.425C16.2833 21.4667 16.825 21.4833 17.275 21.4833C17.5417 21.4833 17.85 21.3 17.85 20.7833C17.85 20.325 17.5833 20.1333 17.325 20.1C16.8083 20.0417 16.4083 19.9583 16.1417 19.8583C15.9417 19.7833 15.8 19.6833 15.7333 19.5833C15.7 19.525 15.6167 19.3417 15.6167 18.825V8.68333C15.6167 8.46667 15.6583 8.4 15.6583 8.4C15.6667 8.4 15.7583 8.34167 16.0583 8.34167H17C17.95 8.34167 18.6667 8.50833 19.125 8.85C19.5833 9.18333 19.9417 9.78333 20.2 10.625C20.275 10.9 20.5083 11.0667 20.8 11.0667C21.5417 11.0667 21.575 10.5583 21.575 10.4583V10.375L21.5667 10.3667Z"
					fill="white"
				/>
			</g>
			<defs>
				<clipPath id="clip0_3780_19923">
					<rect width="15.075" height="14.9833" fill="white" transform="translate(6.5 6.5)" />
				</clipPath>
			</defs>
		</svg>
	);
}
